module.exports = __webpack_public_path__ + "static/media/arrow_down.785d6a90.svg";